import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=0ba841eb&scoped=true&"
import script from "./MyCompany.vue?vue&type=script&lang=ts&"
export * from "./MyCompany.vue?vue&type=script&lang=ts&"
import style0 from "./MyCompany.vue?vue&type=style&index=0&id=0ba841eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba841eb",
  null
  
)

export default component.exports